export const apiHeadersEnum = Object.freeze({
  ORGANIZATION_ID: 'Organization-Id',
  USER_TIMEZONE: 'User-Timezone',
  CONTENT_TYPE: 'Content-Type',
});
